














































import Vue from 'vue'

import { FindTemplates, Template } from '@/api/report'

export default Vue.extend({
  name: 'ReportSetting',
  data() {
    return {
      templates: [] as Template[],
    }
  },

  methods: {
    async findTemplates() {
      this.templates = await FindTemplates()
    },

    gotoNew() {
      this.$router.push('/cems/setting/report/new')
    },
    gotoEdit(id: number) {
      this.$router.push(`/cems/setting/report/${id}/edit`)
    },
  },

  created() {
    this.findTemplates()
  },
})
